<template>
  <div>
    <el-dialog
      :visible.sync="consultingVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="consulting_dialog_app"
    >
      <div
        class="index"
        :class="{
          'is-main': consultingIndex === 0,
          'is-qr': consultingIndex === 1 || consultingIndex === 3,
          'is-phone': consultingIndex === 2
        }"
      >
        <img src="@/assets/appimg/common/f-close.svg" class="close" @click="consultingClose" />
        <template v-if="consultingIndex === 0">
          <img src="@/assets/appimg/common/ch.png" class="head" />
          <div class="index-content">
            <div class="title">穗盈</div>
            <div class="remark">您好，我是穗盈的专属客服</div>
            <div class="remark">请问有什么可以帮助您</div>
            <div class="remark">您可以选择以下咨询方式</div>
          </div>
          <div class="consulting-footer">
            <div class="consulting-item" @click="openCustomerService">
              <img src="@/assets/appimg/common/f3-1.svg" />
              <div class="wz">在线客服</div>
            </div>
            <div class="consulting-item" @click="consultingIndex = 2">
              <img src="@/assets/appimg/common/f4.svg" />
              <div class="wz">咨询热线</div>
            </div>
            <div class="consulting-item" @click="consultingIndex = 3">
              <img src="@/assets/appimg/common/f5.svg" />
              <div class="wz">扫码关注</div>
            </div>
          </div>
        </template>

        <div v-if="consultingIndex === 1" class="wechat">
          <div class="title">微信咨询</div>
          <div class="remark">请长按识别二维码添加客服微信</div>
          <img src="@/assets/appimg/common/f1.jpg" class="code" />
        </div>

        <div v-if="consultingIndex === 2" class="phone">
          <div class="title">咨询热线</div>
          <div class="phone-item">
            <div class="phone-title">总部咨询热线</div>
            <a href="tel:4008838316" class="num">4008838316</a>
          </div>
          <div class="phone-item">
            <div class="phone-title">咨询电话</div>
            <a href="tel:15920366002" class="num">林经理：15920366002</a>
          </div>
          <div class="tips">服务时间：9:00-18:00</div>
        </div>

        <div v-if="consultingIndex === 3" class="wechat">
          <div class="title">扫码关注</div>
          <div class="qr-list">
            <div class="qr-item">
              <img src="@/assets/appimg/common/f1.jpg" class="code" />
              <div class="remark">请长按识别二维码
                <div>添加客服微信</div></div>
            </div>
            <div class="qr-item">
              <img src="@/assets/appimg/common/f2.jpg" class="code" />
              <div class="remark">请长按识别二维码
                <div>关注穗盈公众号</div></div>
            </div>
          </div>

        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "CustCareApp",
  data () {
    return {
      consultingIndex: 0,
      consultingVisible: false
    }
  },
  methods: {
    open() {
      this.consultingIndex = 0
      this.consultingVisible = true
    },
    consultingClose() {
      if(this.consultingIndex === 0) this.consultingVisible = false
      else this.consultingIndex = 0
    },
    openCustomerService() {
      // 关闭咨询弹窗
      this.consultingVisible = false
      // 跳转到独立的客服页面，避免 53KF 悬浮窗挡住底部导航栏
      this.$router.push('/customerServiceApp')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/components/custCare.vue